export default __webpack_public_path__ + "static/media/1142.7fa34b6b.png";